import React from "react";

interface IProps {
  error: string;
}

function ErrorDisplay({ error }: IProps) {
  if (!error) {
    return <></>;
  }
  return (
    <div className="alert alert-danger py-2" role="alert">
      {error}
    </div>
  );
}

export default ErrorDisplay;
